import { CanvasView } from './CanvasView';
import { CanvasList } from './CanvasList';
import { CanvasEdit } from './CanvasEdit';

export const Transformable = {};

Transformable.Edit = CanvasEdit;
Transformable.View = CanvasView;
Transformable.List = CanvasList;
